import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import {
  InsertSignatureInArticlesOfAssociation,
  InsertSignatureInArticlesOfAssociationForm,
} from "./insertSignatureInArticlesOfAssociationDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<InsertSignatureInArticlesOfAssociation>,
  data?: InsertSignatureInArticlesOfAssociation,
): InsertSignatureInArticlesOfAssociationForm {
  return new InsertSignatureInArticlesOfAssociationForm(context, data);
}

export function applyForm(
  form: InsertSignatureInArticlesOfAssociationForm,
): InsertSignatureInArticlesOfAssociation {
  return {
    type: DecisionType.insertSignatureInArticlesOfAssociation,
    paragraph: form.paragraph.parsedValue,
    texts: form.texts.map((m) => ({
      text: m.model.validatedValue,
      language: m.locale,
    })),
    titles: form.titles.map((m) => ({
      text: m.model.validatedValue,
      language: m.locale,
    })),
  };
}

export function validate(form: InsertSignatureInArticlesOfAssociationForm): boolean {
  return form.validate();
}

export function isValid(form: InsertSignatureInArticlesOfAssociationForm): boolean {
  return form.isValid;
}

export const insertSignatureInArticlesOfAssociationHandler: DecisionTypeHandler<
  DecisionType.insertSignatureInArticlesOfAssociation,
  InsertSignatureInArticlesOfAssociation,
  InsertSignatureInArticlesOfAssociationForm
> = {
  type: DecisionType.insertSignatureInArticlesOfAssociation,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
